import { imageExtensions } from '../enums/imageExtensions';
import { mediaTypes } from '../enums/mediaTypes';
import { videoExtensions } from '../enums/videoExtensions';
import { soundExtensions } from '../enums/soundExtensions';
import { AttachmentModel } from '../models/attachment.model';
import { ScanningStatusEnum } from '../enums/scanningStatus.enum';

class MediaUtil {
  /**
   * @desc create a thumbnail url from a video frame at 0:00
   * @param {string} source
   * @param {number} seekTo
   * @return {Promise<string>}
   */
  async createVideoThumbnailUrl(source: string, seekTo: number = 0) {
    const video = document.createElement('video');
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    video.src = source;

    await new Promise<void>(resolve => {
      video.addEventListener('loadedmetadata', () => {
        canvas.height = 400;
        canvas.width = (400 * video.videoWidth) / video.videoHeight;
        video.currentTime = seekTo;
      });
      video.addEventListener('seeked', () => resolve());
    });

    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL();
  }
  /**
   * @desc Prepares media array for update by extracting relevant fields
   * @param {Array} mediaArray - Array of media objects to prepare
   * @return {Array} Array of prepared media objects
   */
  prepareMedia(mediaArray: any[]) {
    return mediaArray
      .filter(med => med.media != null)
      .map(med => ({
        rotationDegree: med.media.rotationDegree,
        tags: med.media.tags.map(tag => tag.id),
        title: med.media.title,
        description: med.media.description,
        id: med.id,
      }));
  }

  isMedia(ext: string) {
    if (imageExtensions.includes(ext.toLowerCase())) {
      return mediaTypes.IMAGE;
    } else if (videoExtensions.includes(ext.toLowerCase())) {
      return mediaTypes.VIDEO;
    } else if (soundExtensions.includes(ext.toLowerCase())) {
      return mediaTypes.SOUND;
    } else {
      return false;
    }
  }
  validateImageResolution(file: File, options: { maxHeight: number; maxWidth: number }): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = () => {
        const isValid = img.width <= options.maxWidth && img.height <= options.maxHeight;
        URL.revokeObjectURL(objectUrl);
        if (isValid) {
          resolve(true);
        } else {
          reject(new Error('Image resolution larger than Max height.'));
        }
      };
      img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('Failed to load image.'));
      };
      img.src = objectUrl;
    });
  }

  filterScannedMediaForProfile(attachments: AttachmentModel[], profileId: number) {
    return attachments.filter(attachment => {
      const hasMedia = attachment.media != null;
      const isCreator = attachment.creator?.profileId === profileId;
      const isBlocked = attachment.media?.file?.scanningStatus === ScanningStatusEnum.BLOCKED;
      return hasMedia && (isCreator || !isBlocked);
    });
  }
}
export const mediaUtil = new MediaUtil();
